import { Chart, VizState } from '@threatadvisor/react-components';
import { Typography } from 'antd';
import React, { ReactElement } from 'react';

type EventVolumeByDayProps = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
};

export default function EventVolumeByDay(props: EventVolumeByDayProps): ReactElement {
  const { reportStart, reportEnd, clientUid } = props;

  const cubeQuery: VizState = {
    chartType: 'line',
    pivotConfig: {
      x: [`security_event.createdDate.day`],
      y: ['security_event.status', 'measures'],
      fillMissingDates: true
      //joinDateRange: false
    },
    query: {
      measures: ['security_event.count'],
      order: {
        'security_event.count': 'desc'
      },
      dimensions: ['security_event.status'],
      timeDimensions: [
        {
          dimension: 'security_event.createdDate',
          granularity: 'day',
          dateRange: [reportStart, reportEnd]
        }
      ],
      filters: [
        {
          member: 'security_event.clientUid',
          operator: 'equals',
          values: [clientUid]
        }
      ]
    }
  };

  return (
    <>
      <h2 className="text-uppercase">Event Volume By Day</h2>
      <figure>
        <Chart
          // hideCubeName
          // useGridTable
          // useHeightBasedOnHowManyItems
          chartConfig={{
            legend: {
              color: {
                title: false,
                position: 'top',
                layout: {
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  flexDirection: 'column'
                }
                //rowPadding: 5,
              }
            },
            scale: {
              x: {
                type: 'time'
                // mask: 'YYYY-MM-DDTHH:mm:ss',
                // utc: true
              }
            },

            colorField: 'series'

            // xAxis: {
            //   label: {
            //     autoRotate: true,
            //     autoEllipsis: false,
            //   },
            // },
          }}
          config={cubeQuery}
        />
        <figcaption>
          <Typography.Text type="secondary">
            Shows trending data for event volume received by day.
          </Typography.Text>
        </figcaption>
      </figure>
    </>
  );
}
